enum CommonStep {
  Dimensions = 'dimensions',
  Weights = 'weights',
  Trims = 'trims',
  EnginesGears = 'enginesGears',
  Colors = 'colors',
  Interiors = 'interiors',
  Equipment = 'equipment',
  Accessories = 'accessories',
  ExtraEquipment = 'extraEquipment',
  VanEquipment = 'vanEquipment',
  ChargingSubscriptions = 'chargingSubscriptions'
}

export default CommonStep;
